import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api, formatApiError } from "../lib/api";
import { VENEZUELA_STATES } from "../lib/constants";
import { Input, Textarea } from "./ContactForm";

export default function EditReport() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [c, setC] = useState(null);
  const [error, setError] = useState("");
  const [msg, setMsg] = useState("");
  const [closeReason, setCloseReason] = useState("");

  useEffect(() => {
    api.get(`/my/reports/${id}`).then((res) => setC(res.data)).catch((e) => setError(formatApiError(e.response?.data?.detail)));
  }, [id]);

  if (error) return <div className="text-center py-12 text-[#475569]">{error}</div>;
  if (!c) return <div className="text-[#475569]">Cargando…</div>;

  const setPerson = (k, v) => setC({ ...c, person: { ...c.person, [k]: v } });
  const loc = c.last_known_location || c.found_location || {};
  const locKey = c.case_type === "missing" ? "last_known_location" : "found_location";
  const setLoc = (k, v) => setC({ ...c, [locKey]: { ...loc, [k]: v } });

  const save = async () => {
    setError(""); setMsg("");
    try {
      await api.put(`/my/reports/${id}`, {
        person: c.person,
        [locKey]: c[locKey],
        approximate_date: c.approximate_date,
      });
      setMsg("Cambios guardados.");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    }
  };

  const requestAction = async (type) => {
    if (!closeReason) { setError("Escribe un motivo."); return; }
    setError(""); setMsg("");
    try {
      await api.post(`/my/reports/${id}/request`, { type, reason: closeReason });
      setMsg("Solicitud enviada al equipo.");
      setCloseReason("");
    } catch (e) {
      setError(formatApiError(e.response?.data?.detail));
    }
  };

  return (
    <div className="max-w-lg mx-auto space-y-5">
      <h1 className="font-heading text-2xl font-bold">Editar reporte <span className="font-mono text-base text-[#94A3B8]">{c.public_case_code}</span></h1>

      <div className="space-y-4">
        <div className="grid grid-cols-2 gap-3">
          <Input label="Nombre" testid="edit-firstname" value={c.person?.first_name || ""} onChange={(v) => setPerson("first_name", v)} />
          <Input label="Apellido" testid="edit-lastname" value={c.person?.last_name || ""} onChange={(v) => setPerson("last_name", v)} />
        </div>
        <Textarea label="Ropa" testid="edit-clothing" value={c.person?.clothing_description || ""} onChange={(v) => setPerson("clothing_description", v)} />
        <Textarea label="Señales particulares" testid="edit-marks" value={c.person?.distinguishing_marks || ""} onChange={(v) => setPerson("distinguishing_marks", v)} />
        <label className="block">
          <span className="text-sm font-medium text-[#475569]">Estado/región</span>
          <select data-testid="edit-state" value={loc.state_region || ""} onChange={(e) => setLoc("state_region", e.target.value)}
            className="mt-1 w-full h-12 px-3 rounded-lg border border-[#E2E8F0] bg-white">
            <option value="">Selecciona</option>
            {VENEZUELA_STATES.map((s) => <option key={s} value={s}>{s}</option>)}
          </select>
        </label>
        <Input label="Municipio" testid="edit-municipality" value={loc.municipality || ""} onChange={(v) => setLoc("municipality", v)} />
        {msg && <p className="text-sm text-[#047857]" data-testid="edit-msg">{msg}</p>}
        {error && <p className="text-sm text-[#DC2626]" data-testid="edit-error">{error}</p>}
        <button onClick={save} data-testid="edit-save-btn" className="w-full h-14 rounded-xl bg-[#1E3A8A] text-white font-semibold">Guardar cambios</button>
      </div>

      <div className="border-t border-[#E2E8F0] pt-5 space-y-3">
        <h2 className="font-heading text-lg font-semibold">Solicitar cierre o retiro</h2>
        <Textarea label="Motivo" testid="edit-request-reason" value={closeReason} onChange={setCloseReason} />
        <div className="flex gap-3">
          <button onClick={() => requestAction("closure")} data-testid="edit-request-close-btn" className="flex-1 h-12 rounded-xl bg-[#F1F5F9] text-[#0F172A] font-medium">Solicitar cierre</button>
          <button onClick={() => requestAction("removal")} data-testid="edit-request-removal-btn" className="flex-1 h-12 rounded-xl bg-[#FEF2F2] text-[#991B1B] font-medium">Solicitar retiro</button>
        </div>
      </div>
    </div>
  );
}
